"use client";
import { jsx } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Carousel as Carousel$1 } from "@mantine/carousel";
import { useViewportSize } from "@mantine/hooks";
import { forwardRef, useRef, useState, useEffect, Children } from "react";
import Section from "../Section/Section.js";
import '../../../assets/Carousel.css';const section = "_section_178ul_2";
const wrapper = "_wrapper_178ul_13";
const root = "_root_178ul_19";
const viewport = "_viewport_178ul_24";
const slide = "_slide_178ul_28";
const container = "_container_178ul_35";
const indicators = "_indicators_178ul_39";
const indicator = "_indicator_178ul_39";
const controls = "_controls_178ul_60";
const control = "_control_178ul_60";
const CarouselStyles = {
  section,
  wrapper,
  root,
  viewport,
  slide,
  container,
  indicators,
  indicator,
  controls,
  control
};
const _Carousel = forwardRef((props, ref) => {
  const {
    children,
    slideGap = "xs",
    slideSize,
    slidesToScroll,
    sectionLink,
    sectionHeader,
    withControls = true,
    variant = "light",
    withIndicators = true,
    centerHeader = true,
    draggable = true,
    align = "start",
    className,
    loop = false,
    ...rest
  } = props;
  const viewport2 = useViewportSize();
  const containerRef = useRef(null);
  const itemRef = useRef(null);
  const [autoSlideSize, setAutoSlideSize] = useState(100);
  const [autoSlidesToScroll, setAutoSlidesToScroll] = useState(1);
  const [hasMultipleSlides, setHasMultipleSlides] = useState(true);
  const hasSlideSize = ["number", "string"].includes(typeof slideSize);
  useEffect(() => {
    if (itemRef.current && containerRef.current) {
      const containerWidth = containerRef.current.clientWidth;
      const itemWidth = parseInt(
        window.getComputedStyle(itemRef.current.firstChild).width.replace("px", ""),
        10
      );
      const itemPerSlide = Math.floor(containerWidth / itemWidth) >= 1 ? Math.floor(containerWidth / itemWidth) : 1;
      const calcAutoSlideSize = 100 / itemPerSlide;
      setAutoSlidesToScroll(itemPerSlide);
      setAutoSlideSize(Number.isFinite(calcAutoSlideSize) ? calcAutoSlideSize : 100);
      setHasMultipleSlides(itemPerSlide < Children.count(children));
    }
  }, [viewport2.width]);
  return /* @__PURE__ */ jsx(
    Section,
    {
      ...rest,
      className: `${CarouselStyles.section} ${className}`,
      header: sectionHeader,
      centerHeader,
      link: sectionLink,
      ref,
      children: /* @__PURE__ */ jsx("div", { ref: containerRef, className: CarouselStyles.wrapper, children: /* @__PURE__ */ jsx(
        Carousel$1,
        {
          align,
          loop,
          mx: "auto",
          mod: { variant },
          withIndicators: withIndicators && hasMultipleSlides,
          withControls: withControls && hasMultipleSlides,
          draggable: draggable === true ? hasMultipleSlides : false,
          controlSize: 48,
          classNames: CarouselStyles,
          slideGap,
          slideSize: slideSize || `${autoSlideSize}%`,
          slidesToScroll: slidesToScroll || autoSlidesToScroll,
          children: Children.map(children, (child, index) => /* @__PURE__ */ jsx(
            Carousel$1.Slide,
            {
              ref: itemRef,
              mod: { "has-slide-size": hasSlideSize },
              children: child
            },
            `carouselItem${index}`
          ))
        }
      ) })
    }
  );
});
_Carousel.displayName = "Carousel";
const Carousel = sharedHandler(_Carousel);
Carousel.displayName = _Carousel.displayName;
export {
  CarouselStyles as C,
  Carousel as default
};
